import { memo, Suspense, useContext } from "react"
import { CardOrderItemStyled, ContentOrderItemstyled } from "components/Core/Order/CardOrder/CardOrderItem.styled"
import {
  IconQrCode,
  IconIoStorefront,
  IconPackgeImport,
  IconBsBookmarkCheck,
  IconAiOutlineSolution,
  IconIoSpeedometerSharp,
  IconFaMotorcycle,
} from "theme/common/Icon.styled"
import { ICardOrderItem } from "interfaces/IOrder"
import Checkbox from "components/Commons/CheckBox"
import { getValueShippinggroupStatusEnum, isValidDisplayData } from "helpers/UtilsHelper"
import { AuthContext } from "context/context/AuthContext"
import { clients } from "webapp-clients/Clients"
import { useTranslation } from "react-i18next"
import { EShippinggroupStatus } from "enums/shippinggroupEmun"
import { useLocation } from "react-router-dom"
import { useEnv } from "hooks"
import UseViewPickupCode from "hooks/UseViewPickupCode"
import { useOutstandingChecker } from "hooks/useOutstandingChecker"

const CardOrderItem = memo(
  ({
    id,
    orderId,
    channel,
    salesChannelId,
    source,
    target,
    shippingType,
    currentStatus,
    canSelect = false,
    handleClickSelectOrder,
    isCheckedOrder,
    statusSG,
    custom,
    showStatus,
    trace,
    basePath,
  }: ICardOrderItem) => {
    const { t } = useTranslation()
    const paramType = statusSG || getValueShippinggroupStatusEnum(currentStatus.tag)

    const {
      state: { user },
    } = useContext(AuthContext)
    const infoSgToPrint = { id, orderId, source, target, custom }
    const TRANSIT = "transit"
    const TRANSIT_TO_SOURCE = "transit_to_source"
    const [_client] = useEnv().multiclient.get_user_env()
    const { pathname } = useLocation<{ type: string }>()

    const TagCustomOrder = user?.mainGroup?.id && clients[user.mainGroup.id as keyof typeof clients]?.TagCustomOrder

    // TODO: this needs refactor, should be removed asap
    const validateStatusTransitPrivilege = (): string => {
      let transitType: string = TRANSIT
      let isConsolidation: boolean = Boolean(custom?.consolidation) || false
      let toMySource: boolean = (user?.currentSources || []).includes(target?.source?.id)
      if (isConsolidation && toMySource) {
        transitType = TRANSIT_TO_SOURCE
      } else if (isConsolidation && !toMySource) {
        transitType = TRANSIT
      } else if (!isConsolidation && toMySource) {
        transitType = TRANSIT_TO_SOURCE
      } else if (!isConsolidation && !toMySource) {
        transitType = TRANSIT
      } else {
        transitType = TRANSIT
      }
      return transitType
    }

    let view_opl = pathname.includes("in_transit_for_reception_opl")

    const get_user_courier = () => {
      let couriers = user?.groups
      couriers = couriers?.filter((courier: any) => courier.type === "Courier").map((courier: any) => courier.id)
      return couriers
    }

    const checkTraceWom = (): any => {
      if (!trace) return false
      let result = trace?.filter((item: any) => item.name === "Despacho recepcionado")
      return result.length > 0 && view_opl ? true : false
    }

    const checkRouteStatusType = (stateUrl: any): string | EShippinggroupStatus => {
      if (currentStatus.frontTag) {
        return currentStatus.frontTag ? TRANSIT_TO_SOURCE : TRANSIT
      }

      if (currentStatus.aliasStatus) {
        if (currentStatus.aliasStatus === EShippinggroupStatus.pending_reversa) {
          return "pending_reversa"
        }
        if (currentStatus.aliasStatus === EShippinggroupStatus.pickup_reversa) {
          return "pickup_reversa"
        }
        if (currentStatus.aliasStatus === EShippinggroupStatus.transit_reversa) {
          return "transit_reversa"
        }
        if (currentStatus.aliasStatus === EShippinggroupStatus.delivered_reversa) {
          return "delivered_reversa"
        }
        if (currentStatus.aliasStatus === EShippinggroupStatus.delivered_system_reversa) {
          return "delivered_system_reversa"
        }
        if (currentStatus.aliasStatus === EShippinggroupStatus.canceled_reversa) {
          return "canceled_reversa"
        }
        return "in_transit_for_reception"
      }

      /*
      if (
        // custom?.infoReversa?.status === "Pendiente de Preparacion" &&
        channel === "reversas" &&
        user?.currentSources?.includes(source?.id) &&
        shippingType === "TR"
      ) {
        return "pending_reversa"
      }
      */

      if (_client === "privilege" && [TRANSIT, TRANSIT_TO_SOURCE].includes(stateUrl)) {
        return validateStatusTransitPrivilege()
      }
      return stateUrl
    }

    const couriers = get_user_courier()

    const renderStatus = (currentStatus: any): string => {
      let _currentStatus = currentStatus.tag

      if (!!currentStatus.frontTag) {
        _currentStatus = currentStatus.frontTag
      }

      if (!!currentStatus.aliasStatus) {
        _currentStatus = currentStatus.aliasStatus
      }

      return couriers?.length ? t(`${_currentStatus}.courierTitle`) : t(`${_currentStatus}.title`)
    }

    const { canIuseViewPickupCode } = UseViewPickupCode()

    const showVDI = () => {
      if (custom?.delivered_vdi) {
        return <span className="pending-label close">VDI Entregado</span>
      } else {
        if (custom?.pending_vdi && currentStatus.tag !== EShippinggroupStatus.closed) {
          return <span className="pending-label">Pendiente VDI</span>
        } else {
          return null
        }
      }
    }

    const showPlanZero = () => {
      if (custom?.planZero?.toUpperCase() === "SI" && currentStatus.tag === EShippinggroupStatus.confirmation) {
        return <span className="label-plan-zero">Plan Zero</span>
      } else {
        return null
      }
    }

    const { checkHasOutstanding } = useOutstandingChecker()

    return (
      <>
        <ContentOrderItemstyled selected={isCheckedOrder}>
          {canSelect && (
            <div className="content-order-checked">
              <Checkbox
                id={id}
                name={id}
                onChange={(ev) => handleClickSelectOrder(ev, infoSgToPrint)}
                checked={isCheckedOrder}
              />
            </div>
          )}
          <CardOrderItemStyled
            className={checkHasOutstanding(custom) && `has-debt`}
            to={`${basePath || '/order'}/${checkRouteStatusType(paramType)}/${id}/${orderId}`}
          >
            <div className="content-item-order">
              {showPlanZero()}

              <span className="relevant-title item">{t(shippingType)}</span>
              <span className="item relevant-title">
                ID canal ventas
                <span className="relevant-title">{salesChannelId}</span>
              </span>
              <span className="item">
                ORDEN
                <span>{orderId}</span>
              </span>

              <span className="item">
                SG
                <span>{id}</span>
              </span>
              {source?.name && (
                <span className="item">
                  Source
                  <span>{source?.name}</span>
                </span>
              )}
              <span className="item">
                Canal
                <span>{channel}</span>
              </span>

              {canIuseViewPickupCode && (
                <>
                  {(custom?.infoEntrega?.codigoEntrega || custom?.infoElocker?.codigoRetiro) &&
                    isValidDisplayData(custom?.infoEntrega?.codigoEntrega) && (
                      <>
                        <p className="item">
                          <IconQrCode />
                          Código de retiro
                          <span>{custom?.infoEntrega?.codigoEntrega}</span>
                        </p>
                      </>
                    )}
                </>
              )}

              {showStatus && (
                <span className="item">
                  Estado
                  <span>{renderStatus(currentStatus)}</span>
                </span>
              )}
            </div>

            {TagCustomOrder && (
              <Suspense fallback={null}>
                <TagCustomOrder custom={custom} />
              </Suspense>
            )}

            {showVDI()}

            {checkHasOutstanding(custom) && <span className="info-label">DEUDA DONANTE</span>}

            {shippingType === "SP" ? (
              <IconIoStorefront className="icon-storepickup-item" title="Retiro en Tienda" />
            ) : null}

            {checkTraceWom() && <IconPackgeImport className="icon-packgeimport-item" title="Despacho Recepcionado" />}

            {statusSG === "in_transit_for_reception" && false ? (
              <IconBsBookmarkCheck className="icon-is_search_approval" title="Visto bueno" />
            ) : null}

            {shippingType === "SP" && !custom?.infoElocker?.isElocker && (
              <IconAiOutlineSolution className="icon-storepickup-meson" title="Retiro Mesón" />
            )}

            {shippingType === "HD" && custom?.deliveryType === "ED" && (
              <IconIoSpeedometerSharp className="icon-storepickup-express-delivery" title="Despacho Express" />
            )}

            {shippingType === "HD" && custom?.deliveryType === "ED" && custom?.courier === "NOMAD" && (
              <IconFaMotorcycle className="icon-delivery-ultra-express" title="Delivery Ultra Express" />
            )}

            {/* <IconArrowRigth className="icon-arrow-rigth" /> */}
          </CardOrderItemStyled>
        </ContentOrderItemstyled>
      </>
    )
  },
)

export default CardOrderItem
